module.exports = __webpack_public_path__ + "static/media/3001.08d79ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/ThreeHundred/3001.png
// module id = 793
// module chunks = 5